import moment from "moment";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Button, Col, Image, Modal, Row, Form } from "react-bootstrap";
import { CircularProgressbar } from "react-circular-progressbar";
import { connect } from "react-redux";
import Alert from "react-s-alert";
//import { FormControl, TextField, Select, IconButton } from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import {
  blockUserFromDetailPage,
  deleteUserFromDetailPage,
  flagUserFromDetailPage,
} from "../../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import CallingButtonPopup from "../../../../reusableComponents/allPopupReusable/CallingButtonPopup";
import CustomSuperAdminNotification from "../../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminNotification";
import CustomSuperAdminResetPassword from "../../../superAdminReusable/reusablePopupSuperAdmin/CustomSuperAdminResetPassword";
import SuperAdminSmsAdmin from "../../../superAdminReusable/reusablePopupSuperAdmin/SuperAdminSmsAdmin";
import EditUser from "../EditUser";
import ViewUser from "../ViewUser";
import SendSMS from "../../../superAdminReusable/reusablePopupSuperAdmin/SendSMS";
import SuperAdminChatWindowPopup from "../../superAdminPendingVendors/SuperAdminChatWindowPopup";
import {
  userReasonForBlock,
  userReasonForFlag,
} from "../../../../../enums/GlobalEnums";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { TextAreaReusableComponent } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";

const SuperAdminReusableTopView = (props) => {
  //state
  let history = useHistory();
  const { userId } = useParams();
  const [showDeleteUser, setShowDeleteUser] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = useState(false);

  const [showBlockUser, seShowBlockUser] = useState(false);
  const handleCloseBlockUser = () => seShowBlockUser(false);
  const handleShowBlockUser = () => seShowBlockUser(true);

  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => {
    setShowEdit(true);
    setShowView(false);
  };
  const handleCloseView = () => setShowView(false);
  const handleShowView = () => {
    setShowView(true);
  };
  const handleCloseDeleteUser = () => {
    setShowDeleteUser(false);
  };
  const [deleteStatus, setDeleteStatus] = useState(false);
  const handleShowDeleteUser = (status) => {
    setDeleteStatus(status);
    setShowDeleteUser(true);
  };

  const onSuccessDelete = () => {
    handleCloseDeleteUser();
    history.push("/superadminallusers");
  };

  const deleteUser = () => {
    let data = {};
    data.is_deleted = !deleteStatus;
    props.deleteUserFromDetailPage(props.data._id, data, onSuccessDelete);
  };
  const onSuccessBlock = () => {
    handleCloseBlockUser();
    setDisabled(false);
    setStage(0);
  };
  const [disabled, setDisabled] = useState(false);
  const blockUser = (id, status) => {
    setDisabled(true);
    let data = {};
    data.user_blocked = !status;
    props.blockUserFromDetailPage(userId, data, onSuccessBlock);
  };

  const onSuccessFlag = () => {
    handleCloseFlag();
    setStage(0);
  };
  const onSuccessArchive = () => {
    handleCloseArchive();
    setStage(0);
    Alert.success(
      `<h4>User ${!props?.data?.isArchive ? "Archived" : "UnArchived"
      } successfully</h4>`,
      {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      }
    );
  };

  const calcProfile = (profilePercent) => {
    if (profilePercent) {
      return profilePercent + "%";
    } else {
      return "0%";
    }
  };

  const [showFlag, seShowFlag] = useState(false);
  const [showArchive, seShowArchive] = useState(false);
  const handleCloseFlag = () => {
    setStage(0);
    seShowFlag(false);
  };
  const handleShowFlag = () => seShowFlag(true);

  const handleCloseArchive = () => {
    setStage(0);
    seShowArchive(false);
  };
  const handleShowArchive = () => seShowArchive(true);
  const [stage, setStage] = useState(0);
  const [reason, setReason] = useState({
    archiveReason: "Junk User (No Transactions for <90 days)",
  });

  const changeStage = (e) => {
    setStage(e);
  };

  const handleFlagUser = (id, status) => {
    let data = { ...reason };
    data.isFlag = !status;
    props.flagUserFromDetailPage(id, data, onSuccessFlag);
  };

  const archiveUser = (id, status) => {
    let data = { archiveReason: reason.archiveReason };
    data.isArchive = !status;
    props.flagUserFromDetailPage(id, data, onSuccessArchive, "ARCHIVE");
  };

  const makeCallingObject = (user) => {
    let formData = {};
    formData.user_details = {};
    formData.user_details.mobile_number = user.mobile_number;
    formData.user_details.country_code = user.country_code;
    formData.user_details.name = user.first_name;

    return formData;
  };
  // console.log(props.data?.wallets[0]?.kycDocType)
  return (
    <>
      <div className="super-admin-users-top-view-box mt-4 mb-5 px-3 py-0 h-auto" style={{ wordBreak: "break-all" }}>
        <Row>
          <Col lg={3}>
            <div className="d-flex justify-content-between">
              <div className="pr-2 d-flex py-3">
                <div className="user-profile-image mr-2">
                  {props &&
                    props.data &&
                    props.data.profile_photo &&
                    props.data.profile_photo?.length >= 1 ? (
                    <Image
                      fluid
                      className="h-100"
                      // src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                      src={props.data.profile_photo}
                    />
                  ) : (
                    <Image
                      fluid
                      src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                    //src={props.data.profile_photo}
                    />
                  )}
                </div>
                <div className="w-100">
                  <div className="f16-700">
                    {props?.data?.first_name} {props?.data?.last_name}
                  </div>
                  <div className="f11-400 mb-3">#{props?.data?._id}</div>
                  <div className="f11-500 mb-1">Member since</div>
                  <div className="f9-400">
                    {moment(props?.data?.createdAt).format("MMMM YYYY")}
                  </div>
                </div>
              </div>
              {/* <div className="d-flex flex-wrap align-items-center py-3 enWidth130">

              </div> */}
            </div>
          </Col>
          <Col lg={3}>
            <Col md={7} className="py-3">

              <div className="f10-400">Phone</div>
              <div className="f13-700 text-dark">
                +91 {props?.data?.mobile_number}
              </div>
              <div className="f10-400 mt-4">KYC Status</div>
              <div className="f13-700 text-dark">
                {props.data?.isWallet ? "Yes" : "No"}
              </div>

              {/* <div className="f13-700 mb-3">KYC is done through {props.data?.wallets[0]?.kycDocType }</div> */}
            </Col>

          </Col>

          <Col lg={3}>
            <Row>
              <Col md={7} className="py-3">
                <div className="f10-400">Email</div>
                <div className="f13-700 mb-3">{props?.data?.email}</div>
                <div className="f10-400 mt-4">KYC Document</div>
                {props?.data?.isWallet ? (<>
                  <div className="f13-700 mb-3">{props?.data?.wallet_id?.kycDocType?.toUpperCase()}</div>
                </>) : (
                  <>
                    <div className="f13-700 mb-3">-</div>
                  </>
                )}
              </Col>
              <Col md={5} className="py-3">
                <div className="f10-400 mb-1">City</div>
                <div className="f13-700 mb-3">
                  {props.data && props.data.city ? props.data.city : "N/A"}
                </div>
                {props?.data?.isWallet && (
                  <>
                    <div className="f10-400 mt-4">KYC Date & Time</div>

                    {props?.data?.wallet_id?.kycCreatedAt ? <><div className="f12-600">
                      {" "}
                      {moment(props?.data?.wallet_id?.kycCreatedAt).format(
                        "Do MMM, YYYY"
                      )}
                    </div>
                      <div className="f12-600">
                        {moment(props?.data?.wallet_id?.kycCreatedAt).format(
                          "LT"
                        )}
                      </div></> : "-"}
                  </>
                )}

              </Col>
            </Row>
          </Col>
          <Col lg={3}>
            <Row>
              <Col md={6} className="pt-3 pb-2">
                <div className="f10-400 mb-1">Status</div>
                <div className="f13-700 mb-3">
                  {props?.data?.user_verified ? "verified" : "Unverified"}
                </div>
                <div className="f10-400 mt-4">Wallet / Added Balance</div>
                {props?.data?.wallet_id?.balance ? (<>
                  <div className="f13-700 mb-3">{(props?.data?.wallet_id?.balance || 0)?.toFixed(2)} / {(props?.data?.wallet_id?.addedBalance || 0).toFixed(2)}</div>
                </>) : (
                  <>
                    <div className="f13-700 mb-3">0/0</div>
                  </>
                )}
              </Col>
              <Col md={6} className="pt-3 pb-2">
                <div className="d-flex align-items-center">
                  <div className="progressCircleTbl">
                    <CircularProgressbar
                      value={
                        props.data && props.data.profile_percentage
                          ? props.data.profile_percentage
                          : 0
                      }
                      text={calcProfile(
                        props.data && props.data.profile_percentage
                      )}
                    />
                  </div>
                  <div className="pl-2">
                    <div className="f13-700">Profile</div>
                    <div className="f13-700">Completed</div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="d-flex align-items-center justify-content-end pb-3">
          <div className="">
            <CallingButtonPopup sendData={makeCallingObject(props.data)} />
          </div>
          <SuperAdminChatWindowPopup
            data={props.data}
            text={"seating"}
            actionType={"USER"}
          />
          <SendSMS
            name={props.data.first_name}
            mobile_number={props.data.mobile_number}
            country_code={props.data.country_code}
          />
          <CustomSuperAdminNotification
            _id={props.data._id}
          ></CustomSuperAdminNotification>
          <Button
            variant="link"
            className="enIconBtn mr-3"
            onClick={handleShowView}
          >
            <Image
              src={require("../../../../../assets/images/UserManagement/eye.svg")}
              alt="View"
              title="View"
              fluid
            />
          </Button>

          <React.Fragment>
            <Button
              variant="link"
              //className="enIconBtn mr-3"
              onClick={handleShowFlag}
              className={
                props.data.isFlag ? "border-0 enIconBtn mr-3" : "enIconBtn mr-3"
              }
            >
              <Image
                src={require("../../../../../assets/images/UserManagement/flag.svg")}
                alt="Flag User"
                title="Flag User"
                fluid
              />
            </Button>
            <Modal show={showFlag} onHide={handleCloseFlag} centered>
              <Modal.Header className="py-0 pt-2 border-0" closeButton>
                <Modal.Title></Modal.Title>
              </Modal.Header>
              <Modal.Body className="f16-500">
                Are you sure to {props.data.isFlag ? "Unflag" : "Flag"} the user
                ?
              </Modal.Body>
              <Modal.Footer className="justify-content-start border-0">
                <Button
                  variant="outline-secondary"
                  className="btn-lg mr-4 px-5"
                  onClick={handleCloseFlag}
                >
                  No
                </Button>
                <Button
                  variant="danger"
                  className="btn-lg px-5"
                  onClick={() =>
                    handleFlagUser(props.data._id, props.data.isFlag)
                  }
                >
                  Yes
                </Button>
              </Modal.Footer>
            </Modal>
          </React.Fragment>

          {/* <SuperAdminBlockUser
                status={props.data.user_blocked}
                yesClicked={(handleCloseBlockUser) =>
                  blockUser(handleCloseBlockUser, props.data.user_blocked)
                }
              /> */}

          <React.Fragment>
            <Button
              variant="link"
              //className="enIconBtn mr-3"
              onClick={handleShowBlockUser}
              className={
                props.data && props.data.user_blocked
                  ? "border-0 enIconBtn mr-3 action_icon_padding p-15px"
                  : "enIconBtn mr-3"
              }
            >
              <Image
                src={
                  props.data && props.data.user_blocked
                    ? require("../../../../../assets/images/ActionImages/image/block.svg")
                    : require("../../../../../assets/images/UserManagement/BlockContact.svg")
                }
                alt="Block User"
                title="Block User"
                fluid
              />
            </Button>
            <Modal show={showBlockUser} onHide={handleCloseBlockUser} centered>
              <Modal.Header className="py-0 pt-2 border-0" closeButton>
                <Modal.Title>
                  {" "}
                  {stage === 1 ? <>Reason for Blocking a User</> : <></>}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="f16-500">
                {stage !== 1 ? (
                  <>
                    Are you sure to{" "}
                    {props.data.user_blocked ? "Unblock" : "Block"} the user ?
                  </>
                ) : (
                  <></>
                )}
                {stage === 1 ? (
                  <>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Status"></InputLabel>
                        <Select
                          value={
                            reason.blockReason ||
                            "Junk User (No Transactions for <90 days)"
                          }
                          onChange={(e) =>
                            setReason({
                              ...reason,
                              blockReason: e.target.value,
                            })
                          }
                          label=""
                          inputProps={{
                            name: "",
                            id: "outlined-Status",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {userReasonForBlock.map((item, index) => (
                            <MenuItem
                              label={item.title}
                              value={item.value}
                              key={item.id + index}
                            >
                              {item.title}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Form.Group>
                    <TextAreaReusableComponent
                      labelText={"Add Comments"}
                      placeholder="Add Comments"
                      onChange={(e) =>
                        setReason({
                          ...reason,
                          blockComments: e.target.value,
                        })
                      }
                    />
                    <div style={{ color: "#9E9E9E" }} className="f12-400">
                      Maximum 150 characters*
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </Modal.Body>
              <Modal.Footer className="justify-content-start border-0">
                <Button
                  variant="outline-secondary"
                  className="btn-lg mr-4 px-5"
                  onClick={handleCloseBlockUser}
                >
                  {stage === 0 ? "No" : "Cancel"}
                </Button>
                <Button
                  variant="danger"
                  className="btn-lg px-5"
                  disabled={disabled}
                  onClick={() =>
                    stage === 0 && !props.data.user_blocked
                      ? changeStage(1)
                      : blockUser(
                        props && props.data._id,
                        props && props.data.user_blocked
                      )
                  }
                >
                  {stage === 0 ? "Yes" : "Send"}
                </Button>
              </Modal.Footer>
            </Modal>
          </React.Fragment>

          <CustomSuperAdminResetPassword
            mobileNo={props.data.mobile_number}
            name={props.data.first_name}
            lastName={props.data.last_name}
            countryCode={props.data?.country_code}
            userId={props.data._id}
          />
          {/* <SuperAdminDeleteUser /> */}

          <Button
            variant="link"
            className="enIconBtn mr-3"
            onClick={() => handleShowDeleteUser(props.data.is_deleted)}
          >
            <Image
              src={require("../../../../../assets/images/UserManagement/Delete.svg")}
              alt="Delete"
              title="Delete User"
              fluid
            />
          </Button>
          <React.Fragment>
            <Button
              variant="link"
              //className="enIconBtn mr-3"
              onClick={handleShowArchive}
              className={
                props.data?.isArchive ? "border-0 enIconBtn mr-3" : "enIconBtn mr-3"
              }
            >
              <Image
                src={require("../../../../../assets/images/UserManagement/archive.png")}
                alt="Archive User"
                title="Archive User"
                fluid
                width={"15px"}
              />
            </Button>
            <Modal show={showArchive} onHide={handleCloseArchive} centered>
              <Modal.Header className="py-0 pt-2 border-0" closeButton>
                <Modal.Title>
                  {stage === 1 ? <>Reason for Archiving a User</> : <></>}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="f16-500">
                {stage !== 1 ? (
                  <>
                    Are you sure to{" "}
                    {props.data.isArchive ? "UnArchiving" : "Archiving"} the
                    user ?
                  </>
                ) : (
                  <></>
                )}
                {stage === 1 ? (
                  <>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Status"></InputLabel>
                        <Select
                          value={
                            reason.archiveReason ||
                            "Junk User (No Transactions for <90 days)"
                          }
                          onChange={(e) =>
                            setReason({
                              ...reason,
                              archiveReason: e.target.value,
                            })
                          }
                          label=""
                          inputProps={{
                            name: "",
                            id: "outlined-Status",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {userReasonForFlag.map((item, index) => (
                            <MenuItem
                              label={item.title}
                              value={item.value}
                              key={item.id + index}
                            >
                              {item.title}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Form.Group>
                    <TextAreaReusableComponent
                      labelText={"Add Comments"}
                      placeholder="Add Comments"
                      onChange={(e) =>
                        setReason({
                          ...reason,
                          archiveComments: e.target.value,
                        })
                      }
                    />
                    <div style={{ color: "#9E9E9E" }} className="f12-400">
                      Maximum 150 characters*
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </Modal.Body>
              <Modal.Footer className="justify-content-start border-0">
                <Button
                  variant="outline-secondary"
                  className="btn-lg mr-4 px-5"
                  onClick={handleCloseArchive}
                >
                  {stage === 0 ? "No" : "Cancel"}
                </Button>
                {console.log(props?.data)}
                <Button
                  variant="danger"
                  className="btn-lg px-5"
                  onClick={() =>
                    stage === 0 && !props.data.isArchive
                      ? changeStage(1)
                      : archiveUser(
                        props.data._id,
                        props?.data?.isArchive
                      )
                  }
                >
                  {stage === 0 ? "Yes" : "Send"}
                </Button>
              </Modal.Footer>
            </Modal>
          </React.Fragment>
        </div>
      </div>

      <Modal show={showDeleteUser} onHide={handleCloseDeleteUser} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete the user ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={handleCloseDeleteUser}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            //onClick={handleCloseDeleteUser}
            onClick={() => deleteUser()}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal show={showEdit} onHide={handleCloseEdit} centered size="lg">
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24-700">Edit User Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          <div className="d-flex">
            <div className="user-profile-image m-0">
              <Image
                src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
              />
            </div>
            <div className="pl-3 pt-2">
              <div className="f21-700 pb-2">
                {props && props.data && props.data.first_name}{" "}
                {props && props.data && props.data.last_name}
              </div>
              <div className="f13-500 greenLbl text-white">
                {props && props.data && props.data.age}
              </div>
            </div>
          </div>
          <EditUser data={props.data} CloseEdit={handleCloseEdit} />
        </Modal.Body>
      </Modal>
      <Modal show={showView} onHide={handleCloseView} centered size="lg">
        <Modal.Header className="border-0 pl-4" closeButton>
          <Modal.Title className="f24-700">View User Details</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4 f16-500">
          <Row>
            <div className="col-md-6 d-flex">
              <div className="user-profile-image m-0">
                {props.data?.profile_photo?.length ? (
                  <Image src={props?.data?.profile_photo[0]} />
                ) : (
                  <Image
                    src={require("../../../../../assets/images/ActionImages/demoprofile.jpg")}
                  />
                )}
              </div>
              <div className="pl-3 pt-2">
                <div className="f21-700 pb-2">
                  {props.data.first_name} {props.data.last_name}
                </div>
                <div className="f13-500 greenLbl text-white">21+</div>
              </div>
            </div>
            <div className="col-md-6 d-flex justify-content-end">
              <div className="d-flex justify-content-end flex-wrap align-items-center">
                <Button
                  variant="link"
                  className="enIconBtn mr-3"
                  onClick={handleShowEdit}
                >
                  <Image
                    src={require("../../../../../assets/images/UserManagement/pencil.svg")}
                    alt="View"
                    title="Edit User"
                    fluid
                  />
                </Button>
                <CallingButtonPopup sendData={makeCallingObject(props.data)} />
                <Button variant="link" className="enIconBtn mr-3">
                  <Image
                    src={require("../../../../../assets/images/UserManagement/forum.svg")}
                    alt="View"
                    title="View"
                    fluid
                  />
                </Button>
                <SuperAdminSmsAdmin
                  first_name={props.data.first_name}
                  mobile_number={props.data.mobile_number}
                />
              </div>
            </div>
          </Row>
          <ViewUser data={props.data} />
        </Modal.Body>
      </Modal>
    </>
  );
};

SuperAdminReusableTopView.propTypes = {
  auth: PropTypes.object.isRequired,
  deleteUserFromDetailPage: PropTypes.func.isRequired,
  blockUserFromDetailPage: PropTypes.func.isRequired,
  flagUserFromDetailPage: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  deleteUserFromDetailPage,
  blockUserFromDetailPage,
  flagUserFromDetailPage,
})(SuperAdminReusableTopView);
